/**************************************************
 * Nombre:       Seccion_Formacion_Detalle
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Home_Testimonios from "./Componentes/Home_Testimonios";
import Formacion_Portada from "./Componentes/Formacion_Portada";
import Formacion_Resolucion_Informacion from "./Componentes/Formacion_Resolucion_Informacion";
import fondo from '../../Recursos/fondo_formacion.svg'
import Formacion_PorQue from "./Componentes/Formacion_PorQue";
import Formacion_Razones from "./Componentes/SucComponentes/Formacion_Razones";
import Formacion_Perfil_Ocupacional from "./Componentes/Formacion_Perfil_Ocupacional";
import Formacion_Plan_Estudios from "./Componentes/Formacion_Plan_Estudios";
import {useContext, useEffect, useState} from "react";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {irArriba} from "../../Utilidades/irArriba";
import {contexApp} from "../../App";
import {useParams} from "react-router-dom";
import Formacion_Perfil_Emprendimiento from "./Componentes/Formacion_Perfil_Emprendimiento";
import Formacion_Lidres from "./Componentes/Formacion_Lidres";


const Seccion_Formacion_Detalle = () => {
    const cData = useContext(contexApp)
    const parms = useParams()
    const {sCell} = useResponsive()
    const [tecnico, setTecnico] = useState({})

    useEffect(() => {

        irArriba()
        if (parms && parms.id) {
            let programas = cData.programas
            let index = programas.findIndex((e) => e.nombre === parms.id.replaceAll('-', ' '))
            if (index >= 0) {
                setTecnico(programas[index])
            }

        }

    }, [parms, cData])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? -1 : 0}}>
                <Formacion_Portada item={tecnico}/>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    backgroundImage: `url(${fondo})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center right',
                }}

            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? 4 : 12}}>
                    <Formacion_Resolucion_Informacion item={tecnico}/>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? 4 : -2}}>
                    <Formacion_PorQue item={tecnico}/>
                </Grid>


            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? 12 : 24}}>
                <Formacion_Razones item={tecnico}/>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', mt: sCell ? 14 : 20, overflowX: 'hidden'}}>
                <Formacion_Perfil_Ocupacional item={tecnico}/>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', mt: sCell ? 14 : 20, overflowX: 'hidden'}}>
                <Formacion_Perfil_Emprendimiento item={tecnico}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? 10 : 18}}>
                <Formacion_Plan_Estudios item={tecnico}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? 10 : 20}}>
                <Formacion_Lidres item={tecnico}/>
            </Grid>


        </Grid>
    )

}
export default Seccion_Formacion_Detalle